export default __webpack_public_path__ + "static/media/61.ccd1d69b.jpeg";